import { useState, useEffect } from 'react';
import axios from 'axios';
import { Play } from 'lucide-react';
import Navbar from '../components/Navbar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Videos() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await axios.get(`${API}/videos`);
      setVideos(response.data);
    } catch (error) {
      console.error('Failed to load videos');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />

      <div className="pt-24 pb-12 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-serif font-bold tracking-tight text-slate-900 mb-4">The Case Verse Videos</h1>
          <p className="text-xl text-slate-600 mb-12">Educational content from our YouTube channel</p>

          {videos.length === 0 ? (
            <div className="text-center py-12 bg-white rounded border border-slate-200">
              <p className="text-slate-600">No videos available yet. Check back soon!</p>
            </div>
          ) : (
            <div className="grid grid-cols-3 gap-6">
              {videos.map((video) => (
                <a
                  key={video.id}
                  href={video.youtube_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white rounded border border-slate-200 overflow-hidden hover:border-slate-900 transition-all"
                >
                  <div className="aspect-video bg-slate-900 flex items-center justify-center">
                    <Play className="w-16 h-16 text-white" />
                  </div>
                  <div className="p-4">
                    <h3 className="font-semibold mb-2">{video.title}</h3>
                    <p className="text-sm text-slate-600">{video.description}</p>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}